import React from "react";
import { Box } from "@ecco/ui/box";
import { GradientWithGrain } from "./ribbon";

export const BoxWithRibbon: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Box position="relative" bg="white" py={6} px={[6, 8]}>
            <GradientWithGrain width="8px" height="100%" />
            {children}
        </Box>
    );
};
